import React, { Component } from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { bindActionCreators } from "redux";
import { Button, Modal, Image, Form } from "react-bootstrap";
import { get } from "lodash";
import {
  getSearchInputData,
  resetSearchInputData
} from "../../../actions/common.action";
import {
  clearUsersListDownloadAction,
  deleteGroupAction,
  getDownloadUsersListAction,
  getGroupsForUserAction,
  getGroupsListAction,
  getUsersListAction,
  migrateProjectAction
} from "../../../actions/userManagement.action";
import DisplayByPermission from "../../../component/DisplayByPermission";
import { MigrationLoaderPage } from "../../../component/Loader";
import { PopUpModel } from "../../../component/PopUp";
import { STATUS, GROUP_ROLE } from "../../../constant";
import { isValidArray } from "../../../helper";
import Pagination from "../../Pagination";
import PermissionHOC from "../../PermissionHOC";
import { LoaderPage } from "../../../component/Loader";
import {
  DownloadExcelReport,
  ModalComponent,
  ModalTemplate,
  Search,
  TableTemplate
} from "../../reusableComponent";
import { PAGE_COUNT } from "../helper";
import { userListHeaderOptions as headerOptions } from "../usermangement.constant";
import CreateUserForm from "./createUser.Form";
import CreateUserEditForm from "./createUserEdit.Form";
import { MigrateProjectComponent } from "./migrateProjectComponent";
import MigratePeople from "../../../assets/migrate.svg";
import CreateUser from "../../../assets/create-user-icon.svg";
import NodalOfficer from "../../../assets/nodal.svg";
import EditImage from "../../../assets/edit-image.svg";
import ViewOnlyIcon from "../../../assets/view-icon.svg";
import hierarchy_action_icon from "../../../assets/hierarchy_action_icon.svg";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { successToastStyle, errorToastStyle } from "../../../customToast";
import request from "../../../services/requestService";
import {
  migrateProjectApi,
  getMigrationLists,
  getGroupHierarchy
} from "../../../services/apiServices";
import OrganizationalChart from "../group/OrganizationalChart";
import ZoomLevelProvider from "../../projectList/ZoomLevelProvider";
const Params = {
  limit: 10,
  offset: 0,
  search: "",
  groupId: "",
  active: true
};

class CreateUserListing extends Component {
  constructor(props) {
    super(props);
    this.userModalRef = React.createRef(); // Create a ref for the modal
    this.state = {
      paginationoffset: 0,
      filteredArray: [],
      noFilterData: false,
      searchInputData: "",
      showBubbleFilter: false,
      selectedFilter: null,
      makeSelectedNull: false,
      usersListParams: { ...Params },
      isUserActive: true,
      displayModal: false,
      loaderDisplay: false,
      migrationLoaderdisplay: false,
      isMigrationmodalDisplay: false,
      notificationOpen: false,
      isModalDisplay: false,
      parentsLevels: [],
      zoomPercentage: null
    };
  }

  componentDidMount() {
    const { getUsersListDispatch, getGroupsForUserAction } = this.props;
    const { usersListParams } = this.state;
    getUsersListDispatch(undefined, usersListParams);
    getGroupsForUserAction(undefined);
  }

  componentWillUnmount() {
    const { resetSearchInputData } = this.props;
    resetSearchInputData();
  }

  onToggleModal = value => {
    this.setState(prevState => ({
      displayModal: !prevState.displayModal
    }));
  };

  onEdit = value => {
    const isEdit = this.state.isEdit;
    this.setState({
      isEdit: !isEdit,
      groupData: (!isEdit && value) || null
    });
  };

  handleClose = () => {
    this.setState(prevState => ({
      isModalDisplay: !prevState.isModalDisplay
    }));
  };

  handleOpen = async value => {
    this.setState({ loaderDisplay: true });
    const response = await request(getGroupHierarchy(value));
    if (response.status) {
      this.setState(prevState => ({
        isModalDisplay: !prevState.isModalDisplay,
        parentsLevels: response.data.data,
        loaderDisplay: false
      }));
    }
  };

  onDeleteAlertToggle = value => {
    const displayDeleteAlert = this.state.displayDeleteAlert;
    this.setState({
      displayDeleteAlert: !displayDeleteAlert,
      deleteData: (!displayDeleteAlert && value) || null
    });
  };

  onDelete = async value => {
    const { deleteGroupDispatch, getGroupsListDispatch } = this.props;
    const { deleteData } = this.state;
    const response = await deleteGroupDispatch(undefined, {
      groupID: get(deleteData, "id", -1)
    });
    if (response) {
      const { status, message } = response;
      (status &&
        toast.success(
          <p className="toast-text-alignment">{message}</p>,
          successToastStyle
        )) ||
        toast.error(
          <p className="toast-text-alignment">{message}</p>,
          errorToastStyle
        );
      status && getGroupsListDispatch(undefined);
    } else {
      toast.error(
        <p className="toast-text-alignment">Please try again</p>,
        errorToastStyle
      );
    }
  };
  handleZoomChange = zoom => {
    this.setState({ zoomPercentage: zoom });
  };

  className = zoomPercentage => {
    if (zoomPercentage == 110) {
      return "action-cell-110";
    } else if (zoomPercentage == 100) {
      return "action-cell";
    } else if (zoomPercentage == 90) {
      return "action-cell-90";
    } else if (zoomPercentage == 80) {
      return "action-cell-80";
    }
  };

  getFilterId = (id, elem) => {
    const { getUsersListDispatch } = this.props;

    if (id === 0) {
      this.removeFilter();
    } else {
      this.setState(
        prevState => ({
          paginationoffset: 0,
          showBubbleFilter: true,
          selectedFilter: elem,
          makeSelectedNull: false,
          usersListParams: {
            ...prevState.usersListParams,
            offset: 0,
            groupId: id
          }
        }),
        () => {
          getUsersListDispatch(undefined, this.state.usersListParams);
        }
      );
    }
  };

  removeFilter = () => {
    const { getUsersListDispatch } = this.props;
    this.setState(
      prevState => ({
        paginationoffset: 0,
        showBubbleFilter: false,
        selectedFilter: null,
        makeSelectedNull: true,
        usersListParams: {
          ...prevState.usersListParams,
          offset: 0,
          groupId: ""
        }
      }),
      () => {
        getUsersListDispatch(undefined, this.state.usersListParams);
      }
    );
  };

  onPageChange = page => {
    const { getUsersListDispatch } = this.props;
    this.setState(
      prevState => ({
        paginationoffset: page.selected || 0,
        usersListParams: {
          ...prevState.usersListParams,
          offset: page.selected || 0,
          limit: PAGE_COUNT
        }
      }),
      () => {
        getUsersListDispatch(undefined, this.state.usersListParams);
      }
    );
  };

  callApiOnSuccess = () => {
    const { getUsersListDispatch } = this.props;
    getUsersListDispatch(undefined, this.state.usersListParams);
  };

  onSearch = (e, values) => {
    const { name, value } = values;
    this.setState(prevState => ({
      paginationoffset: 0,
      usersListParams: {
        ...prevState.usersListParams,
        offset: 0,
        [name]: value
      }
    }));
  };

  callAfterDebounce = () => {
    const { getUsersListDispatch } = this.props;
    this.setState(
      {
        isSearching: true
      },
      async () => {
        await getUsersListDispatch(undefined, this.state.usersListParams);
        this.setState({
          isSearching: false
        });
      }
    );
  };

  onToggleMigrateModal = () => {
    this.setState(prevState => ({
      toggleMigrateModal: !prevState.toggleMigrateModal,
      loaderDisplay: false
    }));
  };

  componentDidUpdate(prevProps) {
    const { success, getUsersListDispatch } = this.props;
    if (success && success !== prevProps.success) {
      this.setState({
        migrationLoaderdisplay: false,
        toggleMigrateModal: false,
        isMigrationmodalDisplay: false
      });
      getUsersListDispatch(undefined, this.state.usersListParams);
    }
  }
  getMigrationAPI = async taskId => {
    let downloadStatus = false;
    let retryCount = 0;
    const maxRetries = 10000;
    const retryDelay = 2000;
    const { getUsersListDispatch } = this.props;
    while (!downloadStatus && retryCount < maxRetries) {
      try {
        const downloadResponse = await request(getMigrationLists(taskId));
        if (downloadResponse.data.data.status === "COMPLETED") {
          downloadStatus = true;
          const message = downloadResponse.data.data.message;
          this.setState({ migrationLoaderdisplay: false });
          toast.success(
            <p className="toast-text-alignment">{message}</p>,
            successToastStyle
          );
          await getUsersListDispatch(undefined, this.state.usersListParams);
          break;
        } else if (downloadResponse.data.data.status === "PARTIAL COMPLETED") {
          downloadStatus = true;
          const message = downloadResponse.data.data.message;
          this.setState({ migrationLoaderdisplay: false });
          toast.success(
            <p className="toast-text-alignment">{message}</p>,
            successToastStyle
          );
          await getUsersListDispatch(undefined, this.state.usersListParams);
          break;
        } else if (downloadResponse.data.data.status === "FAILED") {
          downloadStatus = true;
          const message = downloadResponse.data.data.message;
          this.setState({ migrationLoaderdisplay: false });
          toast.error(
            <p className="toast-text-alignment">{message}</p>,
            errorToastStyle
          );
          await getUsersListDispatch(undefined, this.state.usersListParams);
          break;
        } else {
          retryCount++;
          await new Promise(resolve => setTimeout(resolve, retryDelay));
        }
      } catch (error) {
        retryCount++;
        if (retryCount < maxRetries) {
          await new Promise(resolve => setTimeout(resolve, retryDelay));
        } else {
          console.error("Maximum download retries reached. Download failed.");
          break;
        }
      }
    }
  };

  //  on migrate project
  onSubmitMigrateProject = async () => {
    try {
      const {
        migrateFormData: {
          projectList = [],
          sourceUserID = null,
          targetUserID = null
        }
      } = this.props;
      // if source id not selected
      if (!sourceUserID) {
        return toast.error(
          <p className="toast-text-alignment">From User must be selected</p>,
          errorToastStyle
        );
      }

      // if target is not selected
      if (!targetUserID) {
        return toast.error(
          <p className="toast-text-alignment">To User must be selected</p>,
          errorToastStyle
        );
      }

      // both user id is equal
      if (sourceUserID && targetUserID && sourceUserID.id === targetUserID.id) {
        return toast.error(
          <p className="toast-text-alignment">
            You cannot assign projects to the same user.
          </p>,
          errorToastStyle
        );
      }

      // if not a single project is selected
      if (!projectList.filter(val => val.checked).length) {
        return toast.error(
          <p className="toast-text-alignment">
            Any one project must be selected
          </p>,
          errorToastStyle
        );
      }
      this.setState({ migrationLoaderdisplay: true });
      setTimeout(() => {
        this.setState({ toggleMigrateModal: false });
      }, 58000);
      const response = await request(
        migrateProjectApi({
          projectIds: projectList.filter(val => val.checked).map(val => val.id),
          targetId: targetUserID && targetUserID.id,
          fromId: sourceUserID && sourceUserID.id
        })
      );
      const message = get(response, "data.message");
      const taskID = get(response, "data.data");
      get(response, "data.status")
        ? this.props.handleTaskID(taskID, targetUserID.name, sourceUserID.name)
        : toast.error(
            <p className="toast-text-alignment">{message}</p>,
            errorToastStyle
          );
    } catch (e) {
      console.error(e);
    }
  };

  onUsersListDownload = async () => {
    const { usersListParams } = this.state;
    const { getDownloadUsersListAction } = this.props;
    await getDownloadUsersListAction(undefined, usersListParams);
  };

  handleCheckbox = () => {
    const { isUserActive } = this.state;
    this.setState(
      {
        isUserActive: !isUserActive
      },
      () => {
        this.userListApiCalling();
      }
    );
  };
  userListApiCalling = () => {
    const { getUsersListDispatch } = this.props;
    const { isUserActive } = this.state;
    try {
      if (isUserActive === true) {
        this.setState(
          prevState => ({
            usersListParams: {
              ...prevState.usersListParams,
              active: true
            }
          }),
          () => {
            getUsersListDispatch(undefined, this.state.usersListParams);
          }
        );
      } else {
        this.setState(
          prevState => ({
            usersListParams: {
              ...prevState.usersListParams,
              active: false
            }
          }),
          () => {
            getUsersListDispatch(undefined, this.state.usersListParams);
          }
        );
      }
    } catch (e) {
      console.log(e);
    }
  };
  onClearDownload = () => {
    const { clearUsersListDownloadAction } = this.props;
    clearUsersListDownloadAction();
  };
  setLoading = data => {
    this.setState({
      migrationLoaderdisplay: data,
      toggleMigrateModal: false,
      isMigrationmodalDisplay: true
    });
    this.props.onNotificationChange(Date.now());
  };
  render() {
    const {
      onSearch,
      callAfterDebounce,
      onToggleMigrateModal,
      onSubmitMigrateProject,
      onClearDownload,
      onUsersListDownload,
      setLoading
    } = this;

    const {
      groups,
      usersListing,
      isUserListLoading,
      permission,
      usersListDownload
    } = this.props;
    const {
      displayModal,
      isEdit,
      groupData,
      displayDeleteAlert,
      filteredArray,
      isFilterApplied,
      usersListParams,
      isSearching,
      toggleMigrateModal,
      paginationoffset,
      showBubbleFilter,
      selectedFilter,
      makeSelectedNull,
      isUserActive,
      migrationLoaderdisplay,
      isMigrationmodalDisplay,
      isModalDisplay,
      loaderDisplay,
      parentsLevels,
      zoomPercentage
    } = this.state;
    if (isValidArray(get(usersListing, "data.userDTOList"))) {
      const listData = usersListing.data.userDTOList;
      let groupList = isFilterApplied ? filteredArray : listData;
      if (usersListParams.search) {
        groupList = [];
        listData.forEach(group => {
          if (
            group.name
              .toLowerCase()
              .includes(usersListParams.search.toLowerCase())
          ) {
            groupList.push(group);
          }
        });
      }
    }
    //Filter list based on category
    let filterList = [{ id: 0, name: "Reset All" }];
    if (isValidArray(get(groups, "data"))) {
      groups.data.forEach(elem => {
        filterList.push(elem);
      });
    }
    return (
      <>
        <div className="group-management users-listing">
          <MigrationLoaderPage
            loading={migrationLoaderdisplay}
            setLoading={setLoading}
            className="migration-loader"
          />

          <LoaderPage loading={loaderDisplay} />
          {isModalDisplay && !loaderDisplay ? (
            <OrganizationalChart
              isModalDisplay={isModalDisplay}
              parentsLevels={parentsLevels}
              onClick={this.handleClose}
            />
          ) : null}

          {toggleMigrateModal ? (
            <ModalComponent
              centered
              classes="migrate_modal"
              onClose={onToggleMigrateModal}
              size={"lg"}
              template={
                <ModalTemplate
                  bodyTemplate={<MigrateProjectComponent />}
                  onClose={onToggleMigrateModal}
                  onSubmitTitle="Migrate"
                  onSubmit={onSubmitMigrateProject}
                />
              }
            />
          ) : null}

          <div className="header ">
            <div className="d-flex flex-row">
              <h3>
                Users{" "}
                {(get(usersListing, "data.count") && (
                  <span>({get(usersListing, "data.count")})</span>
                )) ||
                  null}
              </h3>
              <Form.Check
                className={`form-checkbox pl-4 ${
                  isUserActive === true ? "checked" : ""
                }`}
                disabled={!get(permission, "canViewOnlyProject")}
              >
                <Form.Check.Input type="checkbox" />
                <Form.Check.Label
                  className="d-flex"
                  onClick={e => {
                    e.stopPropagation();
                    this.handleCheckbox();
                  }}
                >
                  <div className="pt-1">ACTIVE USERS</div>
                </Form.Check.Label>
              </Form.Check>
            </div>
            <div className="header-buttons d-flex flex-row">
              <div className="issue-list-exposed-filters search-in-user pb-2 pr-4">
                <div className="issue-list-filter-right">
                  <div className="filters-sections">
                    <Search
                      placeholder="Search"
                      keyName="search"
                      onChange={onSearch}
                      value={usersListParams.search}
                      isLoading={isSearching}
                      callAfterDebounce={callAfterDebounce}
                      isSearchingUsers={true}
                      filterList={filterList}
                      getFilterId={this.getFilterId}
                      makeSelectedNull={makeSelectedNull}
                    />
                  </div>
                </div>
              </div>
              <DownloadExcelReport
                isLoading={usersListDownload.isLoading}
                downloadLink={usersListDownload.downloadingSrc}
                onClearDownload={onClearDownload}
                onStartDownloading={onUsersListDownload}
              />
              <DisplayByPermission
                display={
                  get(permission, "migrateProject") &&
                  !get(permission, "canViewOnlyProject")
                }
              >
                <OverlayTrigger
                  trigger="hover"
                  defaultShow={false}
                  placement="bottom"
                  overlay={
                    <Tooltip
                      id={`tooltip-checking`}
                      className="create_project_tolltip"
                    >
                      Migrate Projects
                    </Tooltip>
                  }
                >
                  <Button
                    className="btn-orange create-btn migrate-people-btn"
                    size="sm"
                    onClick={
                      isMigrationmodalDisplay ? null : onToggleMigrateModal
                    }
                    style={{
                      cursor: isMigrationmodalDisplay ? "auto" : "pointer"
                    }}
                  >
                    <div>
                      <Image src={MigratePeople} className="migrate-people" />
                    </div>
                  </Button>
                </OverlayTrigger>
              </DisplayByPermission>
              <DisplayByPermission
                display={
                  get(permission, "createUser") &&
                  !get(permission, "canViewOnlyProject")
                }
              >
                <OverlayTrigger
                  trigger="hover"
                  defaultShow={false}
                  placement="bottom"
                  overlay={
                    <Tooltip
                      id={`tooltip-checking`}
                      className="create_project_tolltip"
                    >
                      Create User
                    </Tooltip>
                  }
                >
                  <Button
                    className={`btn-orange create-btn ${
                      get(permission, "migrateProject") === true
                        ? "create-user-btn"
                        : ""
                    }`}
                    size="sm"
                    onClick={this.onToggleModal}
                  >
                    <div>
                      <Image src={CreateUser} className="create-user" />
                    </div>
                  </Button>
                </OverlayTrigger>
              </DisplayByPermission>
            </div>
          </div>
          {/*  Edit Modal Start **/}

          <Modal
            size="lg"
            show={isEdit}
            onHide={this.onEdit}
            aria-labelledby="example-modal-sizes-title-lg"
            containerClass="edit-user-form"
            className="edit-user-modal-form"
          >
            <div className="modal-box-shadow" ref={this.userModalRef}>
              <Modal.Header closeButton className="header-modal">
                <Modal.Title id="example-modal-sizes-title-lg">
                  {get(permission, "canViewOnlyProject")
                    ? "View User"
                    : "Edit User"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body className="body-modal">
                <CreateUserEditForm
                  togglePopUp={this.onEdit}
                  isEdit={isEdit}
                  groupData={groupData}
                  callApiOnSuccess={this.callApiOnSuccess}
                  permission={permission}
                  userModalRef={this.userModalRef}
                />
              </Modal.Body>
            </div>
          </Modal>
          {/*  Edit Modal End **/}

          {/*  Create Modal **/}
          <Modal
            size="lg"
            show={displayModal}
            onHide={this.onToggleModal}
            aria-labelledby="example-modal-sizes-title-lg"
            className="content-modal  create-user-form"
          >
            <div className="modal-box-shadow" ref={this.userModalRef}>
              <Modal.Header closeButton className="header-modal">
                <Modal.Title id="example-modal-sizes-title-lg">
                  Create User
                </Modal.Title>
              </Modal.Header>
              <Modal.Body className="body-modal  create-user-body-modal">
                <CreateUserForm
                  togglePopUp={this.onToggleModal}
                  callApiOnSuccess={this.callApiOnSuccess}
                  userModalRef={this.userModalRef}
                />
              </Modal.Body>
            </div>
          </Modal>
          {/*  Create Modal End **/}

          {/*  Delete Alert Pop Up **/}

          <PopUpModel
            open={displayDeleteAlert}
            text={"Are you sure you want to delete it?"}
            leftBtnText={"Yes"}
            rightBtnText={"No"}
            onCancel={this.onDeleteAlertToggle}
            onSubmit={this.onDelete}
          />
          {showBubbleFilter ? (
            <div className="applied-filter-list pt-3 mb-0">
              <div className="applied-filter mb-0">
                {selectedFilter && selectedFilter.name}
                <span
                  className="close"
                  onClick={e => {
                    this.removeFilter();
                  }}
                >
                  X
                </span>
              </div>
            </div>
          ) : null}
          <TableTemplate
            isUsersTable={true}
            headersOptions={headerOptions}
            isLoading={isUserListLoading === STATUS.LOADING}
            bodyOptions={get(usersListing, "data.userDTOList")}
            bodyTemplate={(options, index) => (
              <>
                <td>
                  {index + 1 + usersListParams.offset * usersListParams.limit}
                </td>
                <td
                  className={`${
                    options.groupRoles !== null &&
                    (options.groupRoles.includes(
                      GROUP_ROLE.CENTRAL_NODAL_OFFICER
                    ) ||
                      options.groupRoles.includes(
                        GROUP_ROLE.CENTRAL_DEPARTMENT_NODAL_OFFICER
                      ) ||
                      options.groupRoles.includes(
                        GROUP_ROLE.STATE_DEPARTMENT_NODAL_OFFICER
                      ) ||
                      options.groupRoles.includes(
                        GROUP_ROLE.STATE_NODAL_OFFICER
                      )) === true
                      ? "pl-2"
                      : ""
                  }`}
                >
                  <div className="d-flex align-items-center">
                    <div>
                      {options.groupRoles !== null ? (
                        (options.groupRoles.includes(
                          GROUP_ROLE.CENTRAL_NODAL_OFFICER
                        ) ||
                          options.groupRoles.includes(
                            GROUP_ROLE.CENTRAL_DEPARTMENT_NODAL_OFFICER
                          ) ||
                          options.groupRoles.includes(
                            GROUP_ROLE.STATE_DEPARTMENT_NODAL_OFFICER
                          ) ||
                          options.groupRoles.includes(
                            GROUP_ROLE.STATE_NODAL_OFFICER
                          )) === true ? (
                          <OverlayTrigger
                            defaultShow={false}
                            placement="bottom"
                            overlay={
                              <Tooltip
                                id={`tooltip-checking`}
                                className="create_project_tolltip"
                              >
                                Nodal
                              </Tooltip>
                            }
                          >
                            <Image
                              src={NodalOfficer}
                              className="nodal-officer-icon"
                            />
                          </OverlayTrigger>
                        ) : (
                          <></>
                        )
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="pl-2">{options.name}</div>
                  </div>
                </td>
                <td>{options.groupOrganization}</td>
                <td>{options.active ? "Yes" : "No"}</td>
                {/*
                 <td>
                  {get(permission, "updateUser") ? (
                    <OverlayTrigger
                      trigger="hover"
                      defaultShow={false}
                      overlay={
                        <Tooltip
                          id={`tooltip-checking`}
                          className="edit_group_tooltip"
                        >
                          Edit User
                        </Tooltip>
                      }
                    >
                      <Image
                        className={"edit-image"}
                        src={
                          !get(permission, "canViewOnlyProject")
                            ? EditImage
                            : ViewOnlyIcon
                        }
                        onClick={this.onEdit.bind(this, options)}
                      />
                    </OverlayTrigger>
                  ) : null}
                  <OverlayTrigger
                    trigger="hover"
                    defaultShow={false}
                    overlay={
                      <Tooltip
                        id={`tooltip-checking`}
                        className="organizational_hierarchy_tooltip"
                      >
                        Organizational Hierarchy
                      </Tooltip>
                    }
                  >
                    <Image
                      className={"edit-image"}
                      src={hierarchy_action_icon}
                      onClick={this.handleOpen.bind(this, options.groupId)}
                      style={{
                        visibility:
                          options.groupOrganization == null ? "hidden" : null,
                        paddingLeft: 8
                      }}
                    />
                  </OverlayTrigger>
                </td> */}
                <ZoomLevelProvider onZoomChange={this.handleZoomChange} />
                <td className={this.className(zoomPercentage)}>
                  <div className="action-icons">
                    {get(permission, "updateUser") ? (
                      <OverlayTrigger
                        trigger="hover"
                        defaultShow={false}
                        overlay={
                          <Tooltip
                            id="tooltip-edit-user"
                            className="edit_group_tooltip"
                          >
                            Edit User
                          </Tooltip>
                        }
                      >
                        <Image
                          className="user-edit-image "
                          src={
                            !get(permission, "canViewOnlyProject")
                              ? EditImage
                              : ViewOnlyIcon
                          }
                          onClick={this.onEdit.bind(this, options)}
                        />
                      </OverlayTrigger>
                    ) : null}

                    <OverlayTrigger
                      trigger="hover"
                      defaultShow={false}
                      overlay={
                        <Tooltip
                          id="tooltip-org-hierarchy"
                          className="organizational_hierarchy_tooltip"
                        >
                          Organizational Hierarchy
                        </Tooltip>
                      }
                    >
                      <Image
                        className="user-edit-image  hierarchy-icon"
                        src={hierarchy_action_icon}
                        onClick={this.handleOpen.bind(this, options.groupId)}
                        style={{
                          visibility:
                            options.groupOrganization == null
                              ? "hidden"
                              : "visible"
                        }}
                      />
                    </OverlayTrigger>
                  </div>
                </td>
              </>
            )}
            headersTemplate={options => (
              <>
                <th>{options.title}</th>
              </>
            )}
          />

          {isUserListLoading === STATUS.SUCCESS ? (
            <div className="pagination-wrapper">
              <div class="pagination pagination-in-user-listing">
                <Pagination
                  offset={paginationoffset}
                  pageCount={get(usersListing, "data.count") / PAGE_COUNT}
                  onPageChange={this.onPageChange}
                />
              </div>
            </div>
          ) : null}
        </div>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    usersListing: state.userManagementReducer.usersListing,
    groups: state.userManagementReducer.groups,
    isUserListLoading: state.userManagementReducer.isUserListLoading,
    searchInput: state.commonReducer.searchInput,
    migrateFormData: state.userManagementReducer.migrateFormData,
    isProjectMigrating: state.userManagementReducer.isProjectMigrating,
    usersListDownload: state.userManagementReducer.usersListDownload,
    headingDetailsData: state.pmgReducer.headingDetailsData
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getGroupsListDispatch: getGroupsListAction,
      deleteGroupDispatch: deleteGroupAction,
      getUsersListDispatch: getUsersListAction,
      getSearchInputData: getSearchInputData,
      resetSearchInputData: resetSearchInputData,
      migrateProjectAction: migrateProjectAction,
      getGroupsForUserAction,
      getDownloadUsersListAction,
      clearUsersListDownloadAction
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PermissionHOC(CreateUserListing));
